import React from "react";
import {ValueValidator} from "../Validator";
import {OnValidChangeHandler, ValidationComponent} from "./ValidationComponent";
import {RootState} from "../../../../app/store";
import {SelectOption} from "../../select/SelectDropdown";
import {MultiSelectDropdown} from "../../multiSelect/MultiSelectDropdown";

interface Props<PROPERTY, OBJECT> {
    validator: ValueValidator<PROPERTY[]>
    selector: (state: RootState) => PROPERTY[] | undefined;
    fieldName: keyof OBJECT;
    onChange: (value: PROPERTY[]) => any,
    updateValidationStatus: OnValidChangeHandler<OBJECT>,
    label: string;
    options: SelectOption<PROPERTY>[]
    getMessage: (f: string) => string
    isEqual: (a: PROPERTY, b: PROPERTY) => boolean;
    labelAccessory?: React.ReactNode;
    required?: boolean;
}

export const ValidatedMultiSelectField = <PROPERTY, OBJECT>({
                                                                validator,
                                                                selector,
                                                                fieldName,
                                                                onChange,
                                                                updateValidationStatus,
                                                                label,
                                                                options,
                                                                getMessage,
                                                                isEqual,
                                                                labelAccessory,
                                                                required = true
                                                            }: Props<PROPERTY, OBJECT>) => {
    return <ValidationComponent<PROPERTY[], OBJECT>
        onChange={onChange}
        updateValidationStatus={updateValidationStatus}
        fieldName={fieldName}
        required={required}
        selector={selector}
        validator={validator}
        label={label}
        child={(label, value, onChange, required) =>
            <MultiSelectDropdown<PROPERTY>
                title={label}
                isEqual={isEqual}
                isRequired={required}
                value={value}
                handleChange={onChange}
                options={options}
                errorMessage={getMessage(fieldName as string)}
                titleAccessory={labelAccessory}
            />
        }
    />
}
